import React from 'react';

const PriorityBadge = ({ priority, status, onClick }) => {
  if (status === 'Completed' || status === 'Cancelled') return null;

  const isUrgent = priority === 'Urgent';
  return (
    <span
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : 'default',
        fontSize: 11,
        lineHeight: 1,
        padding: '0 1px',
        opacity: isUrgent ? 1 : 0.28,
        color: isUrgent ? '#ea580c' : undefined,
        userSelect: 'none',
        transition: 'opacity 0.12s',
        background: 'none',
        border: 'none',
      }}
      title={isUrgent ? 'Urgent — click to set Normal' : 'Normal — click to set Urgent'}
    >
      {isUrgent ? '★' : '☆'}
    </span>
  );
};

export default PriorityBadge;
